<template>
  <section class="clients section">
    <div class="container">
      <div class="section-header">
        <span class="section-label">典型客户</span>
        <h2 class="section-title">300余家政企用户信赖之选</h2>
        <p class="section-desc">
          深耕政务领域多年，已为湖北省及周边多个地市的300余家政府部门与企事业单位提供数字化转型服务。
        </p>
      </div>

      <p class="clients__note">部分用户展示，排名不分先后</p>

      <div class="clients__grid">
        <div
          v-for="client in clients"
          :key="client"
          class="clients__item"
        >
          {{ client }}
        </div>
      </div>

      <div class="clients__more">
        <a href="#contact" class="btn btn-blue">查看更多案例</a>
      </div>
    </div>
  </section>
</template>

<script>
import { clients } from '../data/site'

export default {
  name: 'ClientSection',
  data() {
    return { clients }
  }
}
</script>

<style scoped>
.clients {
  background: #f7f9fc;
}

.clients__note {
  text-align: center;
  font-size: 13px;
  color: #999;
  margin: -32px 0 32px;
}

.clients__grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.clients__item {
  background: #fff;
  border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 20px 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #444;
  transition: all 0.25s;
}

.clients__item:hover {
  border-color: #0052d9;
  color: #0052d9;
  box-shadow: 0 4px 16px rgba(0, 82, 217, 0.08);
}

.clients__more {
  text-align: center;
  margin-top: 40px;
}

@media (max-width: 960px) {
  .clients__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 560px) {
  .clients__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
